import { useEffect, useState } from "react";
import styles from "./index.module.scss";

const ProjectDisplay = ({ projectDisplayData = {} }) => {
  const projects = projectDisplayData.project || [];

  const [country, setCountry] = useState(null);

  useEffect(() => {
    const load = () => {
      setCountry(sessionStorage.getItem("countrySelected"));
    };

    load();

    window.addEventListener("countryChanged", load);

    return () => {
      window.removeEventListener("countryChanged", load);
    };
  }, []);

  let showCountryClass = "block";
  if (country) {
    showCountryClass =
      country === projectDisplayData.country ? "block" : "hidden";
  }

  return (
    <div className={styles.wrapper}>
      <div className={`koh-project-display ${showCountryClass}`}>
        {projectDisplayData.country && (
          <div className="koh-project-country-title">
            <h3 className="col-lg-6 col-md-6 col-sm-6 col-xs-12 [font-family:helveticaRoman,Helvetica-Light,sans-serif]">
              {projectDisplayData.country}
            </h3>
          </div>
        )}
        {Array.isArray(projects) &&
          projects.map((project, index) => {
            const fields = project?.fields;
            if (!fields) return null;
            const imageFields = fields.image?.fields;
            const imageUrl = imageFields?.imageUrl;
            const imageAlt = imageFields?.alt || "";
            return (
              <div
                className="koh-project-display-items col-lg-4 col-md-4 col-sm-4 col-xs-12"
                key={project.sys?.id || index}
              >
                {fields.href ? (
                  <a href={fields.href}>
                    <div className="koh-project-display-items-inner">
                      {imageUrl && (
                        <img
                          className="featured-box-image"
                          src={imageUrl}
                          alt={imageAlt}
                        />
                      )}
                      {(fields.title || fields.location) && (
                        <div className="koh-project-display-content">
                          {fields.title && <p>{fields.title}</p>}
                          {fields.location && <span>{fields.location}</span>}
                        </div>
                      )}
                    </div>
                  </a>
                ) : (
                  <div className="koh-project-display-items-inner">
                    {imageUrl && (
                      <img
                        className="featured-box-image"
                        src={imageUrl}
                        alt={imageAlt}
                      />
                    )}
                    {(fields.title || fields.location) && (
                      <div className="koh-project-display-content">
                        {fields.title && <p>{fields.title}</p>}
                        {fields.location && <span>{fields.location}</span>}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};
export default ProjectDisplay;
